import gql from 'graphql-tag';
import { ErrorsAttributes } from '../constants';
import { LabelFragment } from './labels';

export const ConnectorCoreAttributes = `
id
name
category
`;

export const CascadeConnectorCoreAttributes = `
${ConnectorCoreAttributes}
cascadeUrl
`;

export const GenericSelectorConnectorCoreAttributes = `
${ConnectorCoreAttributes}
attrName
attrValueRegex
cmsUrl
cssSelector
selectorType
`;

export const GoogleAnalyticsConnectorCoreAttributes = `
${ConnectorCoreAttributes}
googleAccessTokenPresent
ga4PropertyId
sites {
  id
  name
  url
  labels {
    ...LabelFragment
  }
}
`;

export const OmniupdateConnectorCoreAttributes = `
${ConnectorCoreAttributes}
defaultIndexFileName
ouAccount
ouUrl
site
skin
`;

export const SitefinityConnectorCoreAttributes = `
${ConnectorCoreAttributes}
cmsUrl
homepageFilename
`;

export const TaskIssueTrackerConnectorCoreAttributes = `
${ConnectorCoreAttributes}
githubEnabled
gitlabEnabled
jiraEnabled
`;

export const ConnectorsQuery = gql`
  query ConnectorsQuery($accountId: String, $page: Int, $perPage: Int, $sortBy: ConnectorsSortBy!, $sortOrder: SortOrder!, $search: String) {
    connectors(accountId: $accountId, page: $page, perPage: $perPage, sortBy: $sortBy, sortOrder: $sortOrder, search: $search) {
      currentPage
      perPage
      totalPages
      totalEntries
      nodes {
        ...on CascadeConnector {
          ${CascadeConnectorCoreAttributes}
        }
        ...on GenericSelectorConnector {
          ${GenericSelectorConnectorCoreAttributes}
        }
        ...on GoogleAnalyticsConnector {
          ${GoogleAnalyticsConnectorCoreAttributes}
        }
        ...on OmniupdateConnector {
          ${OmniupdateConnectorCoreAttributes}
        }
        ...on SitefinityConnector {
          ${SitefinityConnectorCoreAttributes}
        }
        ...on TaskIssueTrackerConnector {
          ${TaskIssueTrackerConnectorCoreAttributes}
        }
      }
    }
  }
  ${LabelFragment}
`;

export const GoogleAnalyticsConnectorsQuery = gql`
  query GoogleAnalyticsConnectorsQuery($accountId: String, $page: Int, $perPage: Int, $sortBy: ConnectorsSortBy!, $sortOrder: SortOrder!, $search: String) {
    connectors(accountId: $accountId, page: $page, perPage: $perPage, sortBy: $sortBy, sortOrder: $sortOrder, search: $search) {
      currentPage
      perPage
      totalPages
      totalEntries
      nodes {
        ...on GoogleAnalyticsConnector {
          ${GoogleAnalyticsConnectorCoreAttributes}
        }
      }
    }
  }
  ${LabelFragment}
`;

export const ConnectorQuery = gql`
  query ConnectorQuery($connectorId: String!, $accountId: String!) {
    connector(connectorId: $connectorId, accountId: $accountId) {
      ...on CascadeConnector {
        ${CascadeConnectorCoreAttributes}
      }
      ...on GenericSelectorConnector {
        ${GenericSelectorConnectorCoreAttributes}
      }
      ...on GoogleAnalyticsConnector {
        ${GoogleAnalyticsConnectorCoreAttributes}
        availableGa4Properties {
          id
          name
          account {
            id
            displayName
          }
        }
      }
      ...on OmniupdateConnector {
        ${OmniupdateConnectorCoreAttributes}
      }
      ...on SitefinityConnector {
        ${SitefinityConnectorCoreAttributes}
      }
      ...on TaskIssueTrackerConnector {
        ${TaskIssueTrackerConnectorCoreAttributes}
      }
    }
  }
  ${LabelFragment}
`;

export const CreateCascadeConnectorMutation = gql`
  mutation CreateCascadeConnector($accountId: String!, $name: String, $category: ConnectorCategory, $cascadeUrl: String) {
    createCascadeConnector(accountId: $accountId, name: $name, category: $category, cascadeUrl: $cascadeUrl) {
      connector {
        ${CascadeConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const UpdateCascadeConnectorMutation = gql`
  mutation UpdateCascadeConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $cascadeUrl: String) {
    updateCascadeConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, cascadeUrl: $cascadeUrl) {
      connector {
        ${CascadeConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const CreateGenericSelectorConnectorMutation = gql`
  mutation CreateGenericSelectorConnector($accountId: String!, $name: String, $category: ConnectorCategory, $selectorType: GenericSelectorType, $cssSelector: String, $attrName: String, $attrValueRegex: String, $cmsUrl: String) {
    createGenericSelectorConnector(accountId: $accountId, name: $name, category: $category, selectorType: $selectorType, cssSelector: $cssSelector, attrName: $attrName, attrValueRegex: $attrValueRegex, cmsUrl: $cmsUrl) {
      connector {
        ${GenericSelectorConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const UpdateGenericSelectorConnectorMutation = gql`
  mutation UpdateGenericSelectorConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $selectorType: GenericSelectorType, $cssSelector: String, $attrName: String, $attrValueRegex: String, $cmsUrl: String) {
    updateGenericSelectorConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, selectorType: $selectorType, cssSelector: $cssSelector, attrName: $attrName, attrValueRegex: $attrValueRegex, cmsUrl: $cmsUrl) {
      connector {
        ${GenericSelectorConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const CreateOmniupdateConnectorMutation = gql`
  mutation CreateOmniupdateConnector($accountId: String!, $name: String, $category: ConnectorCategory, $ouUrl: String, $defaultIndexFileName: String, $skin: String, $ouAccount: String, $site: String) {
    createOmniupdateConnector(accountId: $accountId, name: $name, category: $category, ouUrl: $ouUrl, defaultIndexFileName: $defaultIndexFileName, skin: $skin, ouAccount: $ouAccount, site: $site) {
      connector {
        ${OmniupdateConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const UpdateOmniupdateConnectorMutation = gql`
  mutation UpdateOmniupdateConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $ouUrl: String, $defaultIndexFileName: String, $skin: String, $ouAccount: String, $site: String) {
    updateOmniupdateConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, ouUrl: $ouUrl, defaultIndexFileName: $defaultIndexFileName, skin: $skin, ouAccount: $ouAccount, site: $site) {
      connector {
        ${OmniupdateConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const CreateSitefinityConnectorMutation = gql`
  mutation CreateSitefinityConnector($accountId: String!, $name: String, $category: ConnectorCategory, $cmsUrl: String, $homepageFilename: String) {
    createSitefinityConnector(accountId: $accountId, name: $name, category: $category, cmsUrl: $cmsUrl, homepageFilename: $homepageFilename) {
      connector {
        ${SitefinityConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const UpdateSitefinityConnectorMutation = gql`
  mutation UpdateSitefinityConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $cmsUrl: String, $homepageFilename: String) {
    updateSitefinityConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, cmsUrl: $cmsUrl, homepageFilename: $homepageFilename) {
      connector {
        ${SitefinityConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const CreateTaskIssueTrackerConnectorMutation = gql`
  mutation CreateTaskIssueTrackerConnector($accountId: String!, $name: String, $category: ConnectorCategory, $githubEnabled: Boolean, $gitlabEnabled: Boolean, $jiraEnabled: Boolean) {
    createTaskIssueTrackerConnector(accountId: $accountId, name: $name, category: $category, githubEnabled: $githubEnabled, gitlabEnabled: $gitlabEnabled, jiraEnabled: $jiraEnabled) {
      connector {
        ${TaskIssueTrackerConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const UpdateGoogleAnalyticsConnectorMutation = gql`
  mutation UpdateGoogleAnalyticsConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $ga4PropertyId: String, $googleAccessToken: String, $googleRefreshToken: String, $siteIds: [String!]) {
    updateGoogleAnalyticsConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, ga4PropertyId: $ga4PropertyId, googleAccessToken: $googleAccessToken, googleRefreshToken: $googleRefreshToken, siteIds: $siteIds) {
      connector {
        ${GoogleAnalyticsConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
  ${LabelFragment}
`;

export const CreateGoogleAnalyticsConnectorMutation = gql`
  mutation CreateGoogleAnalyticsConnector($accountId: String!, $name: String, $category: ConnectorCategory, $ga4PropertyId: String, $googleAccessToken: String, $googleRefreshToken: String, $siteIds: [String!]) {
    createGoogleAnalyticsConnector(accountId: $accountId, name: $name, category: $category, ga4PropertyId: $ga4PropertyId, googleAccessToken: $googleAccessToken, googleRefreshToken: $googleRefreshToken, siteIds: $siteIds) {
      connector {
        ${GoogleAnalyticsConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
  ${LabelFragment}
`;

export const UpdateTaskIssueTrackerConnectorMutation = gql`
  mutation UpdateTaskIssueTrackerConnector($accountId: String!, $connectorId: String!, $name: String!, $category: ConnectorCategory, $githubEnabled: Boolean, $gitlabEnabled: Boolean, $jiraEnabled: Boolean) {
    updateTaskIssueTrackerConnector(accountId: $accountId, connectorId: $connectorId, name: $name, category: $category, githubEnabled: $githubEnabled, gitlabEnabled: $gitlabEnabled, jiraEnabled: $jiraEnabled) {
      connector {
        ${TaskIssueTrackerConnectorCoreAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;

export const DestroyConnectorMutation = gql`
  mutation DestroyConnector($accountId: String!, $connectorId: String!) {
    destroyConnector(accountId: $accountId, connectorId: $connectorId) {
      status
    }
  }
`;

export const DestroyConnectorsMutation = gql`
  mutation DestroyConnectors($accountId: String!, $connectorIds: [String!]!) {
    destroyConnectors(accountId: $accountId, connectorIds: $connectorIds) {
      status
    }
  }
`;

export const connectorTypes = [
  { type: 'GenericSelectorConnector', category: 'cms_deep_link', label: 'Generic Selector' },
  { type: 'GoogleAnalyticsConnector', category: 'analytics', label: 'Google Analytics' },
  { type: 'CascadeConnector', category: 'cms_deep_link', label: 'Cascade CMS' },
  { type: 'OmniupdateConnector', category: 'cms_deep_link', label: 'OmniUpdate' },
  { type: 'SitefinityConnector', category: 'cms_deep_link', label: 'Sitefinity' },
  { type: 'TaskIssueTrackerConnector', category: 'task_issue_tracker', label: 'Task Issue Tracker' }
];

export const selectorTypes = ['id', 'url'];

export const connectorStateDefaults = {
  name: '',
  category: '',
  cascadeUrl: '',
  attrName: '',
  attrValueRegex: '',
  cmsUrl: '',
  cssSelector: '',
  selectorType: '',
  defaultIndexFileName: '',
  ouAccount: '',
  ouUrl: '',
  site: '',
  skin: '',
  homepageFilename: '',
  googleAccessToken: '',
  googleAccessTokenPresent: false,
  googleRefreshToken: '',
  ga4PropertyId: '',
  availableGa4Properties: [],
};
